import progress from 'nprogress'
import Authentication from '@packages/authentication'
import { NavigationGuardNext, Route } from 'vue-router'
import { Store } from 'vuex'
import { VueRouter } from 'vue-router/types/router'
import UserModule from '@api/module/customer/user/UserModule'
import LoginDialogModule from '@/portal/store/login/LoginDialogModule'

const queryString = require('query-string')

let queryId = ''
let schoolName = process.env.VUE_APP_TITLE

try {
  const queryInfo = queryString.parse(window.location.search.replace(/\?/, ''))
  queryId = queryInfo.schoolId
  if (queryInfo.schoolName) {
    schoolName = queryInfo.schoolName
  }
} catch (e) {
  // todo
  console.log(queryId, schoolName)
}

export default function(router: VueRouter, store: Store<any>, $authentication: Authentication) {
  router.beforeEach(async (to: Route, from: Route, next: NavigationGuardNext) => {
    // 如果有token，就放行
    console.log(store, $authentication)
    if (Authentication.hasToken('customer')) {
      progress.start()
      await UserModule.queryUserInfo()
      window.localStorage.wmUserInfo = JSON.stringify({ userId: UserModule.userInfo?.userId, projectVersion: '1.0.0' })
      next()
    } else {
      if (from?.meta?.needLogin && to?.meta?.needLogin) {
        await LoginDialogModule.setShowLoginDialog(true)
      } else {
        progress.start()
        // 如果标识为需要登录的， 并且没有token的直接返回首页
        if (to?.meta?.needLogin) {
          next('/home')
        } else {
          next()
        }
      }
    }
    progress.done()
  })
  return router
}
